<div class="spinner-border text-primary" role="status">
  <span class="visually-hidden">{{ text() || 'Laden…' }}</span>
</div>
@if (text()) {
  <span class="loading-spinner__text">{{ text() }}</span>
}
